const ingredientsWrappers = document.querySelectorAll('.custom-instruction__bottom');
if (ingredientsWrappers.length > 0) {
  ingredientsWrappers.forEach(wrapper => {
    const ATCButton = wrapper.querySelector('.js_article_products_ATC_button');
    const inputFields = wrapper.querySelectorAll('.article_product_input_field');
    const moneyElement = wrapper.querySelector('.all_products_money');
    const ingredientText = wrapper.querySelector('.js_custom_instruction_text');
    if (ATCButton) {
      ATCButton.addEventListener('click', () => {
        addSelectedProductsToCart(ATCButton, wrapper);
      });
    }
    if (inputFields.length > 0) {
      inputFields.forEach(input => {
        input.addEventListener('change', () => {
          updateATCButtonState(inputFields, ATCButton, moneyElement, ingredientText);
        });

        const parentElement = input.closest('.custom-instruction__product');
        if (parentElement) {
          const variantSelector = parentElement.querySelector('.product_variant_selector');
          if (variantSelector) {
            variantSelector.addEventListener('change', () => {
              updateVariantSelectorState(variantSelector, parentElement, inputFields, ATCButton, moneyElement, ingredientText);
            });
          }
        }
      });
    }
  });
}

function updateVariantSelectorState(currentSelector, mainWrapper, inputFields, ATCButton, moneyElement, ingredientText) {
  const variantID = currentSelector.value;
  const currentPrice = parseFloat(currentSelector.options[currentSelector.selectedIndex].getAttribute('data_current_pro_price'));

  const innerPrice = mainWrapper.querySelector('.custom-ins__content h4 .current_money');
  if (innerPrice) {
    innerPrice.textContent = `${currentPrice.toFixed(2).replace('.', ',')}`;
  }

  const variantUpdateElement = mainWrapper.querySelector('.product_variant_id');
  if (variantUpdateElement) {
    variantUpdateElement.setAttribute('data_variant_id', variantID);
    variantUpdateElement.setAttribute('data_current_pro_price', currentPrice);
  }
  updateATCButtonState(inputFields, ATCButton, moneyElement, ingredientText);

}

function updateATCButtonState(inputFields, ATCButton, moneyElement, ingredientText) {
  const checkedInputs = Array.from(inputFields).filter(input => input.checked);
  const checkedCount = checkedInputs.length;
  if (ATCButton) {
    ATCButton.disabled = checkedCount === 0;
  }

  const totalPrice = checkedInputs.reduce((acc, curr) => {
    const closestProductWrapper = curr.closest('.custom-instruction__product');
    const variantPriceElement = closestProductWrapper?.querySelector('.product_variant_id');
    const variantPrice = variantPriceElement ? parseFloat(variantPriceElement.getAttribute('data_current_pro_price')) : 0;
    return acc + variantPrice;
  }, 0);

  if (moneyElement) {
    moneyElement.textContent = `${totalPrice.toFixed(2).replace('.', ',')}`;
  }

  if (ingredientText) {
    if (checkedCount > 3) {
      ingredientText.removeAttribute('hidden');
    } else {
      ingredientText.setAttribute('hidden', true);
    }
  }
}

async function addSelectedProductsToCart(ATCButton, wrapper) {
  ATCButton.setAttribute('disabled', true);
  ATCButton.setAttribute('aria-busy', true);  
  const itemsArray = [];
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  const inputFields = wrapper.querySelectorAll('.article_product_input_field');
  const inputChecked = Array.from(inputFields).filter(input => input.checked);  
  if (inputChecked.length === 0) {
    ATCButton.removeAttribute('disabled');
    ATCButton.removeAttribute('aria-busy');
    return;
  }
  inputChecked.forEach(input => {
    const closestInstructionWrapper = input.closest('.custom-instruction__product');
    const variantIDEle = closestInstructionWrapper.querySelector('.product_variant_id');    
    if (variantIDEle) {
      const variantID = variantIDEle.getAttribute('data_variant_id');
      if (variantID) {
        itemsArray.push({ id: variantID, quantity: 1 });
      }
    }
  });
  if (itemsArray.length === 0) {
    ATCButton.removeAttribute('disabled');
    ATCButton.removeAttribute('aria-busy');
    return;
  }
  
  const sectionsToRender = cart.getSectionsToRender();
  if (!sectionsToRender || sectionsToRender.length === 0) {
    console.error('No sections to render found');
    ATCButton.removeAttribute('disabled');
    ATCButton.removeAttribute('aria-busy');
    return;
  }

  const headers = {
    method: "POST",
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ 
      items: itemsArray,
      sections: sectionsToRender.map(section => section.id),
      sections_url: window.location.pathname
    })
  };

  try {
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, headers);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    cart.renderContents(data);
  } catch (error) {
    console.error('Error adding products to cart:', error);
  } finally {
    ATCButton.removeAttribute('disabled');
    ATCButton.removeAttribute('aria-busy');
  }
}


window.updateCustomQauantitySelector = function(){  
  const AllCustomQuantityWrapper = document.querySelectorAll('.js-quantity-tier-block');
  if(AllCustomQuantityWrapper.length > 0){
    AllCustomQuantityWrapper.forEach(quantity_wrapper=>{
      const allQuantityOptions = quantity_wrapper.querySelectorAll('.quantity-option');
      if(allQuantityOptions.length > 0){
        allQuantityOptions.forEach(option=>{
          option.addEventListener('click', ()=> updateCustomQuantity(option, quantity_wrapper));
        });
      }
    })
  }
}

window.mainQuantitySelectorUpdate = function(){
  const mainProductContainer = document.querySelectorAll('.product__info-container');
  if(mainProductContainer.length > 0){
    mainProductContainer.forEach(container=>{
      const mainQuantitySelector = container.querySelector('.quantity__input[name="quantity"]');
      if(mainQuantitySelector){
        mainQuantitySelector.addEventListener('change', ()=> updateProgressbarOnMainQuantitySelector(mainQuantitySelector, container));
      }
    })
  }
}

function updateProgressbarOnMainQuantitySelector(currentTarget, container){
  const currentQty = parseInt(currentTarget.value);
  const quantityWrapper = container.querySelector('.js-quantity-tier-block');
  if(quantityWrapper){
    const selectedQty = quantityWrapper.querySelectorAll('.selected-qty');
    if(selectedQty.length > 0) selectedQty.forEach(qty=> {qty.innerText = currentQty});
    const allQuantityOptions = quantityWrapper.querySelectorAll('.quantity-option');
    if(allQuantityOptions.length > 0){
      allQuantityOptions.forEach(option=>{
        const data_qty = parseInt(option.getAttribute('data-qty'));
        option.classList.remove('selected');
        option.classList.toggle('tier-unlocked', data_qty <= currentQty);   
      })
      const matchedTier = quantityWrapper.querySelector(`.quantity-option[data-qty="${currentQty}"]`);
      if(matchedTier){
        matchedTier.classList.add('selected');
      }
    }
    updateProgressbar(currentTarget, quantityWrapper, true);
  }
}

function updateCustomQuantity(currentTarget, quantityWrapper){
  const closestProductWrapper = currentTarget.closest('.product__info-wrapper');
  const currentQty = parseInt(currentTarget.getAttribute('data-qty'));
  const selectedQty = quantityWrapper.querySelectorAll('.selected-qty');
  if(selectedQty.length > 0) selectedQty.forEach(qty=> {qty.innerText = currentQty});
  const allQuantityOptions = quantityWrapper.querySelectorAll('.quantity-option');
  if(allQuantityOptions.length > 0){
    allQuantityOptions.forEach(option=>{
      option.classList.remove('selected');
    })
  }
  currentTarget.classList.add('selected');
  if(closestProductWrapper){
    const main_quantity_input = closestProductWrapper.querySelector('input[name="quantity"]');
    if(main_quantity_input){
      main_quantity_input.value = currentQty;
      main_quantity_input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  updateProgressbar(currentTarget, quantityWrapper, false);
}

function updateProgressbar(currentTarget, quantityWrapper, isMainQuantitySelector) {
  const closestProgressbar = quantityWrapper?.querySelector('.progress-bar-fill');
  const allQuantityOptions = quantityWrapper.querySelectorAll('.quantity-option');
  const allQuantityTierOptions = quantityWrapper.querySelectorAll('.quantity-option.tier-unlocked');
  
  const quantityOptionCount = allQuantityOptions.length;
  const quantityTierOptionCount = allQuantityTierOptions.length;
  let updatedWidth = 0;
  if (isMainQuantitySelector) {
    updatedWidth = Math.floor((quantityTierOptionCount / quantityOptionCount) * 100);
  } else {
    allQuantityOptions.forEach((option, index) => {
      if (option.classList.contains('selected')) {
        updatedWidth = Math.floor(((index + 1) / quantityOptionCount) * 100);
      }
    });
  }
  if (closestProgressbar) {
    closestProgressbar.style.width = `${updatedWidth}%`;
  }
}


window.updateCustomQauantitySelector();
window.mainQuantitySelectorUpdate();

// Show Frozen Product Error Message.
window.enabledFrozenProductErrorMessage = function(){  
  const CustomCheckooutButton = document.querySelectorAll('.notify_frozen_pro_error');
  if(CustomCheckooutButton.length > 0){
    CustomCheckooutButton.forEach(button=>{
      button.addEventListener('click', ()=>{
        var closestCartDrawer = '';
        if(button.closest('cart-drawer')){
          closestCartDrawer = button.closest('cart-drawer');
        } else{
          closestCartDrawer = button.closest('#main-cart-footer');
        }
        // console.log(closestCartDrawer);
        if(closestCartDrawer){
          const error_element = closestCartDrawer?.querySelector('.js-frozen_pro_not_exceed_error');
          if(error_element){
            error_element.removeAttribute('hidden');
            setTimeout(()=>{
              error_element.setAttribute('hidden', true);
            }, 3000);
          }
        }
      })
    })
  }
}
window.enabledFrozenProductErrorMessage();

// Trigger Klaviyo BIS form on Collection Page.
window.BISformCollection = function(){ 
  const allNotifyButtons = document.querySelectorAll('.notify-wrapper');
  if(allNotifyButtons.length > 0){
    allNotifyButtons.forEach(wrapper=>{
      const triggerButton = wrapper.querySelector('.js-call-klaviyo-form');
      const js_klaviyo_form_wrappe = wrapper.querySelector('.js-klaviyo-custom-trigger-container');
      if(triggerButton && js_klaviyo_form_wrappe){
        triggerButton.addEventListener("mouseenter", function () {
          wrapper.classList.add("hovered");
        });
  
        // On mouse leave, remove the class
        triggerButton.addEventListener("mouseleave", function () {
          wrapper.classList.remove("hovered");
        });
        
        triggerButton.addEventListener('click',()=>{
          console.log(triggerButton);
          const klaviyo_bis_trigger = js_klaviyo_form_wrappe.querySelector('.klaviyo-bis-trigger');
          if(klaviyo_bis_trigger) klaviyo_bis_trigger.click();
        });      
      }
    })
  }
}

window.BISformCollection();

const timeStringToSeconds = (timeString) => {
    const timeParts = timeString.split(':').map(part => parseInt(part, 10) || 0);
    let totalSeconds = 0;

    if (timeParts.length === 3) {
        // Format: HH:MM:SS
        const [hours = 0, minutes = 0, seconds = 0] = timeParts;
        totalSeconds = (hours * 3600) + (minutes * 60) + seconds;
    } else if (timeParts.length === 2) {
        // Format: MM:SS
        const [minutes = 0, seconds = 0] = timeParts;
        totalSeconds = (minutes * 60) + seconds;
    } else if (timeParts.length === 1) {
        // Format: SS
        totalSeconds = timeParts[0];
    }

    return totalSeconds;
};

// Update counter on the cart page.
window.updateTimeCounter = function (){  
  const allTimeCounterContainers = document.querySelectorAll('.js-cart-timer-container');
  
  if (allTimeCounterContainers.length > 0) {
      allTimeCounterContainers.forEach(container => {
          const timeMinute = container.querySelector('.js_remaining_counter').getAttribute('data-timelimit');
          
          let timeRemaining = timeStringToSeconds(timeMinute);
          
          const updateTimer = () => {
              const hours = Math.floor(timeRemaining / 3600);
              const minutes = Math.floor((timeRemaining % 3600) / 60);
              const seconds = timeRemaining % 60;
  
              const formattedTime = hours > 0 
                  ? `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
                  : minutes > 0 
                      ? `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
                      : `${String(seconds).padStart(2, '0')}`;
  
              container.querySelector('.js_remaining_counter').textContent = formattedTime;
  
              timeRemaining--;
  
              if (timeRemaining < 0) {
                  clearInterval(timerInterval);
                  container.querySelector('.js_remaining_counter').textContent = hours > 0 
                      ? "00:00:00" 
                      : minutes > 0 
                          ? "00:00" 
                          : "00";
              }
          };
          
          const timerInterval = setInterval(updateTimer, 1000);
      });
  }
}
window.updateTimeCounter();
// Enable Flickity on Related Products
// window.initFlickityOnRelatedProducts = function (){
//   const AllFlickitySliders = document.querySelectorAll('.enable-flickity-slider');
//   if(AllFlickitySliders.length > 0){
//     AllFlickitySliders.forEach(element=>{
//       var flickity = new Flickity(element, {
//         cellAlign: 'left',
//         contain: true,
//         pageDots: false,
//         wrapAround: false,
//         prevNextButtons: false,
//         draggable: true,
//       })
//     })
//   }
// }

window.initFlickityOnRelatedProducts = (function () {
  let flickityInstances = [];

  function initOrDestroyFlickity() {
    const width = window.innerWidth;
    const allSliders = document.querySelectorAll('.enable-flickity-slider');

    if (width > 749) {
      allSliders.forEach((element, index) => {
        if (!flickityInstances[index] || flickityInstances[index].destroyed) {
          flickityInstances[index] = new Flickity(element, {
            cellAlign: 'left',
            contain: true,
            pageDots: false,
            wrapAround: false,
            prevNextButtons: false,
            draggable: true,
          });
        }
      });
    } else {
      flickityInstances.forEach(instance => {
        if (instance && !instance.destroyed) {
          instance.destroy();
        }
      });
      flickityInstances = [];
    }
  }

  initOrDestroyFlickity();

  window.addEventListener('resize', () => {
    initOrDestroyFlickity();
  });
  return initOrDestroyFlickity;
})();

// See More button functionality
window.seeMoreButton = function(){
  const AllSeeMoreButton = document.querySelectorAll('.js-see-more-less-button');
  if(AllSeeMoreButton.length > 0){
    AllSeeMoreButton.forEach(button=>{
      button.addEventListener('click', ()=>{
        updateSeeMoreButton(button);
      })
    })
  }  
  function updateSeeMoreButton(currentTarget){
    const SeeMoreText = currentTarget.getAttribute('data-see-more');
    const SeeLessText = currentTarget.getAttribute('data-see-less')
    const closestProductListWrapper = currentTarget.closest('.js-product-list-wrapper');
    console.log(closestProductListWrapper);
    if(closestProductListWrapper){
      const AllSelectedLists = closestProductListWrapper.querySelectorAll('.js-see-more-button-applied');
      if(AllSelectedLists.length > 0){
        AllSelectedLists.forEach(list=>{
          if(list.classList.contains('see-more-hidden')){
            list.classList.remove('see-more-hidden');
            currentTarget.innerText = SeeLessText;
          } else{
            list.classList.add('see-more-hidden');
            currentTarget.innerText = SeeMoreText;
          }
        })
      }
    }
  }
}

if (window.innerWidth < 750) {
  window.seeMoreButton();
}
window.addEventListener('resize', () => {
  if (window.innerWidth < 750) {
    window.seeMoreButton();
  }
});

document.addEventListener("DOMContentLoaded", function () {
    // Select all elements with class 'scroll_btn'
    const scrollButtons = document.querySelectorAll('.scroll_btn');

    scrollButtons.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault(); // Prevent default anchor behavior

        // Get the href attribute (target ID)
        const targetId = btn.getAttribute('href');

        // Find the target element
        const targetElement = document.querySelector(targetId);

        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth'
          });
        }
      });
    });
  });

// window.onload = function () {
//   const popup = document.querySelector('.frozen-products__popup');
//   if (popup) {
//     // popup.classList.add('frozen-popup__active');
//     // document.body.classList.add('frozen-popup__active');
//     document.addEventListener('click', function (event) {
//       if (!popup.contains(event.target)) {
//         popup.classList.remove('frozen-popup__active');
//         document.body.classList.remove('frozen-popup__active');
//       }
//     });
//   }
// };


// async function openFrozenProductPopup (currentTarget){
//   if(currentTarget){
//     const closestProductInfo = currentTarget.closest('product-info');
//     if(closestProductInfo){
//       const frozenPopup = closestProductInfo.querySelector('.frozen-products__popup');
//       if(frozenPopup){
//         const closeButton = frozenPopup.querySelector('.js-close-frozen-popup'); 
//         frozenPopup.classList.add('frozen-popup__active');
//         document.body.classList.add('frozen-popup__active');
//         const closePopup = () => {
//             CloseFrozenPopup(frozenPopup);
//             resolve(); // Resolve the promise when the popup is closed
//         };
//         document.addEventListener('click', function (event) {
//           if (!frozenPopup.contains(event.target)) {
//             CloseFrozenPopup(frozenPopup);
//           }
//         });
//         closeButton.addEventListener('click',()=> CloseFrozenPopup(frozenPopup));
//       }
//     }
//   }
// }

async function openFrozenProductPopup(currentTarget) {
  if (currentTarget) {
    const popupStatus = await verifyPopupStatus();
    if(popupStatus) return;
    
    const closestProductInfo = currentTarget.closest('.js-has-frozen-product');
    if (closestProductInfo) {
      const frozenPopup = closestProductInfo.querySelector('.frozen-products__popup');
      if (frozenPopup) {
        const dummyPopupWrap = document.querySelector('.frozen-popup-wrap');
        dummyPopupWrap.innerHTML = frozenPopup.outerHTML;
        return new Promise((resolve) => {        
          const closeButton = dummyPopupWrap.querySelector('.js-close-frozen-popup');
          dummyPopupWrap.querySelector('.frozen-products__popup').classList.add('frozen-popup__active');
          document.body.classList.add('frozen-popup__active');
          const closePopup = () => {
              CloseFrozenPopup(dummyPopupWrap.querySelector('.frozen-products__popup'));
              resolve(); // Resolve the promise when the popup is closed
          };
          document.addEventListener('click', function (event) {
            if (!frozenPopup.contains(event.target)) closePopup();
          });
          closeButton.addEventListener('click', closePopup);        
        });
      }
    }
  }
}

async function verifyPopupStatus(){
  const response = await fetch(`${window.Shopify.routes.root}cart.js`);
  const responseData = await response.json();
  const cartItems = responseData.items;
  var has_frozenProduct = false;
  const alreadyHaveFrozenProduct = Array.from(cartItems).some(item => item.properties.hasOwnProperty('_has_frozen_product'));
  return alreadyHaveFrozenProduct;
}

function CloseFrozenPopup(popupEle){
  popupEle.classList.remove('frozen-popup__active');
  document.body.classList.remove('frozen-popup__active');
}


document.addEventListener("DOMContentLoaded", function () {
  
function updateSortByFilter() {  
    const windowURL = window.location.href;
    const isCollectionPage = windowURL.includes('/collections/all');
    
    if (!isCollectionPage) return;
    
    const urlParams = new URLSearchParams(window.location.search);
    const currentSortBy = urlParams.get('sort_by');
    if (currentSortBy === 'best-selling') return;
    const sortSelects = document.querySelectorAll('#SortBy, #SortBy-mobile, #FacetSortDrawerForm #SortBy');
    
    sortSelects.forEach(sortSelect => {
      if (sortSelect) {
        const bestSellingOption = sortSelect.querySelector('option[value="best-selling"]');
        if (bestSellingOption) {
          sortSelect.value = 'best-selling';
          bestSellingOption.selected = true;
          const changeEvent = new Event('change', { bubbles: true });
          sortSelect.dispatchEvent(changeEvent);
          const inputEvent = new Event('input', { bubbles: true });
          sortSelect.dispatchEvent(inputEvent);
        }
      }
    });
  }
  
  updateSortByFilter();
});


function equalizeCardHeadings() {
  
  const headings = document.querySelectorAll('ul#product-grid li.grid__item .card__content h3');
  
  
  headings.forEach(h => h.style.height = 'auto');

  
  let maxHeight = 0;
  headings.forEach(h => {
    maxHeight = Math.max(maxHeight, h.offsetHeight);
  });

  
  headings.forEach(h => {
    h.style.height = `${maxHeight}px`;
  });
}

// Initial run
equalizeCardHeadings();
window.addEventListener('resize', equalizeCardHeadings);




document.addEventListener("DOMContentLoaded", function () {
  const slides = document.querySelectorAll(".slideshow__slide");
  const popups = document.querySelectorAll(".custom-announce__popup");

  // Function to close all popups
  function closeAllPopups() {
    popups.forEach(popup => popup.classList.remove("active"));
    document.body.classList.remove("announcement__popup-open");
  }

  // Open popup on slide click
  slides.forEach(slide => {
    slide.addEventListener("click", function (event) {
      const target = slide.getAttribute("data-popup-target");
      // Check if matching popup exists
      const popup = document.querySelector(`.custom-announce__popup[data-popup-target="${target}"]`);
      
      // ✅ Only proceed if both data attributes match
      if (popup && popup.getAttribute("data-popup-target") === target) {
        closeAllPopups(); // Close others
        popup.classList.add("active");
        document.body.classList.add("announcement__popup-open");
        event.stopPropagation(); // Prevent outside click handler
      } else {
        closeAllPopups(); // No valid match, close all
      }
    });
  });

  // Close popup on close icon click
  popups.forEach(popup => {
    const closeIcon = popup.querySelector(".announce__closeicon");
    if (closeIcon) {
      closeIcon.addEventListener("click", function (e) {
        e.stopPropagation();
        closeAllPopups();
      });
    }
  });

  // Close on outside click
  document.addEventListener("click", function (event) {
    if (
      !event.target.closest(".custom-announce__popup") &&
      !event.target.closest(".slideshow__slide")
    ) {
      closeAllPopups();
    }
  });
});



// document.addEventListener('DOMContentLoaded', function () {
//   const accountIcon = document.querySelector('.header__icon--account');
//   const loginModal = document.querySelector('.custom-main-login');
//   const closeIcon = document.querySelector('.close-icon');

//   if (!accountIcon || !loginModal) return;

//   // Show modal
//   accountIcon.addEventListener('click', function (e) {
//     e.stopPropagation(); // Prevent bubbling to document
//     document.body.classList.add('custom-main-login-open');
//   });

//   // Hide modal when clicking close icon
//   if (closeIcon) {
//     closeIcon.addEventListener('click', function (e) {
//       e.stopPropagation();
//       document.body.classList.remove('custom-main-login-open');
//     });
//   }

//   // Hide modal when clicking outside the modal
//   document.addEventListener('click', function (e) {
//     if (
//       document.body.classList.contains('custom-main-login-open') &&
//       !loginModal.contains(e.target) &&
//       !accountIcon.contains(e.target)
//     ) {
//       document.body.classList.remove('custom-main-login-open');
//     }
//   });
// });

$(document).ready(function() {

  $('.header__icons .enable_mobilepopup__login').click(function(e) {
    e.stopPropagation(); // Prevent bubbling to document
    $('body').addClass('custom-main-login-open');
    $('.custom-main-login').addClass('custom-main-login-open');
  });

  // Close button inside modal
  $('.custom-main-login button.close-icon').click(function(e) {
    e.stopPropagation();
    $('body').removeClass('custom-main-login-open');
    $('.custom-main-login').removeClass('custom-main-login-open');
  });

  // Close modal on outside click
  $(document).click(function(e) {
    // Check if the click target is outside the modal
    if (!$(e.target).closest('.custom-main-login, .header__icon--account').length) {
      $('body').removeClass('custom-main-login-open');
      $('.custom-main-login').removeClass('custom-main-login-open');
    }
  });

  // Prevent clicks inside modal from bubbling to document
  $('.custom-create__account .custom-signup').click(function(e){
    e.stopPropagation();
$('body').removeClass('custom-main-login-open');
    $('.custom-main-login').removeClass('custom-main-login-open');
    $('body').addClass('custom-main-register-open');
    $('.custom-popup__register').addClass('custom-main-register-open');
});
  $('.custom-popup__register button.close-icon').click(function(e){
    e.stopPropagation();
    $('body').removeClass('custom-main-register-open');
    $('.custom-popup__register').removeClass('custom-main-register-open');
  });

  //  $(document).click(function(e) {
  //   // Check if the click target is outside the modal
  //   if (!$(e.target).closest('.custom-main-login, .header__icon--account').length) {
  //     $('body').removeClass('custom-main-register-open');
  //   $('.custom-popup__register').removeClass('custom-main-register-open');
  //   }
  // });
// $(document).on('click', '.already-have__account .custom-signin', function() {
//   alert('clicked');

//   // Remove register modal classes
//   $('body').removeClass('custom-main-register-open');
//   $('.custom-popup__register').removeClass('custom-main-register-open');

//   // Add login modal classes
//   $('body').addClass('custom-main-login-open');
//   $('.custom-main-login').addClass('custom-main-login-open');
// });
//   // Open login modal
  $('.custom-signin').click(function(e){
    e.stopPropagation();
      $('body').removeClass('custom-main-register-open');
  $('.custom-popup__register').removeClass('custom-main-register-open');

  // Add login modal classes
  $('body').addClass('custom-main-login-open');
  $('.custom-main-login').addClass('custom-main-login-open');
  });

  $(".password-toggle").on("click", function () {
  const targetId = $(this).data("target");
  const passwordInput = $("#" + targetId);
  const toggle = $(this);

  if (passwordInput.attr("type") === "password") {
    passwordInput.attr("type", "text");
    toggle.addClass("showing");
  } else {
    passwordInput.attr("type", "password");
    toggle.removeClass("showing");
  }
});

  
  
});
